import { z } from "zod";
import { ExpertPartnerSchema } from "./expert-details";

// Customer story details schema from API response
export const CustomerStoryDetailsSchema = z.object({
    id: z.string(),
    title: z.string().default(''),
    slug: z.string().default(''),
    expertSlug: z.string().default(''),
    period: z.string().optional().nullable().transform((val) => val || undefined),
    images: z.array(z.string()).optional().nullable().default([]).transform((val) => val || []),
    hiredOnShopexperts: z.boolean().optional().nullable().default(false).transform((val) => val || false),
    appsAndThemes: z.array(ExpertPartnerSchema).optional().nullable().default([]).transform((val) => val || []),
    contentHtml: z.string().default(''),
});

export type CustomerStoryDetails = z.infer<typeof CustomerStoryDetailsSchema>;

